module.exports = __webpack_public_path__ + "static/Auto-Share-4-e1407759028633-5fdc14dbdfb0b5864640d12805a6591d.jpg";